import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

export default {
    mixins: [emCommonUtilMixin],
    props: {
        fields: Array,
        items: Array,
        readOnly: {
            type: Boolean,
            default: false
        },
        rowKey: {
            type: String,
            default: 'id'
        },
        enableRowCheck: {
            type: Boolean,
            default: false
        },
        rowClickCheck: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            localFields: [],
            fieldList: [],
            rowList: [],

            selected: [],
            checkedIds: new Set(),
            checkForceLoad: true,

            preLength: 0,
            isImmediate: true,

            tableLoading: false,
            initFinish: false,

            // frozenRows: null,
        };
    },
    computed: {
        isSelectAll() {
            return this.selected.length === this.finalRowList.length && this.selected.length !== 0;
        },
        isSelectNone() {
            return this.selected.length === 0;
        },
        isSelectOne() {
            return this.selected.length === 1;
        },
    },
    watch: {
        rowList: {
            deep: true,
            handler() {
                if (this.rowList.length !== this.preLength || (this.rowList.length > 0 && !this.rowList[0].hasOwnProperty('_index'))) {
                    let index = 1;
                    this.rowList.forEach(o => o._index = index++);
                    this.preLength = this.rowList.length;
                }
                if (!this.isImmediate) {
                    this.$emit('dataChange', this.rowList);
                } else {
                    this.isImmediate = false;
                }
                // if (this.hasDIEdit()) {
                //     this.frozenRows = this.finalRowList;
                // } else {
                //     this.frozenRows = null;
                // }
            },
            immediate: true
        },
        loading() {
            this.tableLoading = this.loading;
        },
    },
    mounted() {
        this.initFinish = true;
    },
    methods: {
        onRowSelected(items) {
            this.selected = items
        },
        changeLoading(val) {
            this.tableLoading = val;
        },
        deepCopy(source) {
            return this.deepCopyObj(source);
        },
        translateFieldConfig(config) {
            let tempList = [];
            for (let item of config) {
                let temp = {};
                temp.key = item.key;
                temp.label = item.label;
                let type = item.form.type;
                if (type !== undefined) {
                    if (type === 'select') {
                        temp.type = type;
                        temp.options = item.form.options;
                    } else if (type === 'entitySelect') {
                        temp.type = 'select';
                        temp.options = this.$store.state[item.form.entity].selectItems;
                    } else if (type === 'boolean') {
                        temp.type = 'select';
                        temp.options = [
                            {value: true, text: '是'},
                            {value: false, text: '否'}
                        ];
                    } else {
                        temp.type = 'input';
                    }
                    temp.form = {
                        type: type
                    }
                }
                tempList.push(temp);
            }
            return tempList;
        },
        mutativeFieldType(data) {
            let row = data.item;
            let mutativeType = data.field.mutativeType;
            if (mutativeType && mutativeType.length > 0) {
                for (let item of mutativeType) {
                    if (row[item.key] === item.value) {
                        return item.activeType;
                    }
                }
            }
            return data.field.type;
        },

        changeRowCheckStatus(row, checked) {
            let rowId = row[this.rowKey];
            if (rowId) {
                if (checked) {
                    this.checkedIds.add(rowId);
                    this.selected.push(row);
                } else {
                    this.checkedIds.delete(rowId);
                    for (let i = 0; i < this.selected.length; i++) {
                        let item = this.selected[i];
                        if (item[this.rowKey] === rowId) {
                            this.selected.splice(i, 1);
                            break;
                        }
                    }
                }
            }
        },
        emitCheckEvent() {
            this.$emit('rowChecked', this.getCheckedIds())
        },
        handleRowCheckEvent(row, checked) {
            this.changeRowCheckStatus(row, checked);
            this.emitCheckEvent();
        },
        getCheckedIds() {
            return Array.from(this.checkedIds);
        },
        getCheckedRows() {
            return this.selected;
        },
    }
}
